import React from 'react';
import bookPromise from '~/models/book-titles';
import './book-tile.scss';
import BookTileDisplay from './book-tile-display';
export default function BookTile({ book: [book] }) {
    const info = useBookInfo(book.id);
    return React.createElement(BookTileDisplay, { book: Object.assign(Object.assign({}, book), { bookState: info === null || info === void 0 ? void 0 : info.book_state, promoteSnippet: info === null || info === void 0 ? void 0 : info.promote_snippet }) });
}
function useBookInfo(id) {
    const [state, setState] = React.useState();
    React.useEffect(() => {
        bookPromise.then((items) => setState(items.find((i) => i.id === id)));
    }, [id]);
    return state;
}
